<div class="rfid-card-scan-container">
  <h1>{{'Please scan a RFID card' | translate }}</h1>
  <app-scan-rfid-card-image></app-scan-rfid-card-image>
</div>
